import React from 'react'
import Component from '@reactions/component'
import PageLoader from 'components/PageLoader'
import Session from 'components/Session'
import withQueryParams from 'components/withQueryParams'
import { authenticate } from 'redux-simple-auth'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { withNotifier } from 'stylist'

const RouteSetToken = ({ authenticate, query }) => (
  <Component
    didMount={() => authenticate('unified', query.get('token'))}
    render={() => (
      <Session
        render={({ authenticated, hasFailedAuth }) =>
          hasFailedAuth || authenticated ? (
            <Redirect to={query.get('return_to') || '/'} replace />
          ) : (
            <PageLoader />
          )
        }
      />
    )}
  />
)

export default compose(
  connect(
    null,
    { authenticate }
  ),
  withQueryParams,
  withNotifier
)(RouteSetToken)



// WEBPACK FOOTER //
// ./src/routes/set-token.js